// Local part follows RFC 5322 dot-atom: dot-separated atoms, no leading/trailing/double dots.
const EMAIL_LOCAL_PART =
  "[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:[.][a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*";
// Every domain label may contain digits and hyphens, not just the first one, so
// multi-level domains like ci.example-city.co.us (common for municipalities) validate.
const DOMAIN_LABEL = '[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?';
const EMAIL_DOMAIN = `${DOMAIN_LABEL}(?:[.]${DOMAIN_LABEL})*[.][a-zA-Z]{2,}`;
const EMAIL_SOURCE = `${EMAIL_LOCAL_PART}@${EMAIL_DOMAIN}`;
const PHONE_SOURCE = '[0-9]{10}';

export const SML_REGEX =  {
  username: new RegExp(`^(?:${PHONE_SOURCE}|${EMAIL_SOURCE})$`), // Regex for Username validation which can be Phone number or email address
  emailOrPhone: new RegExp(`^(?:${PHONE_SOURCE}|${EMAIL_SOURCE})$`),
  email: new RegExp(`^${EMAIL_SOURCE}$`),
  price: /^-?(0|[1-9]\d*)?$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+.,/\w:;<=>?@\w[\\\]^_`{|}~-])(?=.{7,})/,
  record_email: new RegExp(`^${EMAIL_SOURCE}$`)

}
